//#region IMPORTS
import { v4 as uuidv4 } from "uuid";
import { ReactNode } from "react";
import { Tooltip } from "react-tooltip";
import classNames from "../../helpers/classNames";
//#endregion

//#region INTERFACE
interface Props {
  needHelpMessage?: string;
  needHelpId?: string;
  clickHandler: () => void;
  disabled?: boolean;
  children: ReactNode;
}
//#endregion
export default function PaginationBarClientButton({
  needHelpMessage,
  needHelpId = uuidv4(),
  clickHandler,
  disabled = false,
  children,
}: Props) {
  //#region RENDER
  return (
    <button
      data-tooltip-content={needHelpMessage}
      data-tooltip-id={needHelpId}
      className={classNames(
        disabled ? "text-gray-300" : "hover:text-emerald-500 hover:cursor-pointer text-gray-600"
      )}
      disabled={disabled}
      onClick={clickHandler}
    >
      {children}
      {needHelpMessage && !disabled && <Tooltip id={needHelpId} />}
    </button>
    //#endregion
  );
}
